import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            component: () => import('@/components/layout/AppLayout.vue'),
            meta: { requiresAuth: true },
            children: [
                {
                    path: '',
                    name: 'home',
                    component: () => import('@/views/HomeView.vue'),
                },
                {
                    path: 'mis-partes',
                    name: 'mis-partes',
                    component: () => import('@/views/MisPartesView.vue'),
                },
                {
                    path: 'mis-partes/:idParte',
                    name: 'parte-detail',
                    component: () => import('@/views/ParteDetailView.vue'),
                },
                {
                    path: 'mi-agenda',
                    name: 'mi-agenda',
                    component: () => import('@/views/MiAgendaView.vue'),
                },
                {
                    path: 'mis-avisos',
                    name: 'mis-avisos',
                    component: () => import('@/views/MisAvisosView.vue'),
                },
                {
                    path: 'mis-avisos/:idAviso',
                    name: 'aviso-detail',
                    component: () => import('@/views/AvisoDetailView.vue'),
                },
                {
                    path: 'clientes',
                    name: 'clientes',
                    component: () => import('@/views/ClientesView.vue'),
                },
                {
                    path: 'clientes/:idc',
                    name: 'cliente-detail',
                    component: () => import('@/views/ClienteDetailView.vue'),
                },
                {
                    path: 'search',
                    name: 'search',
                    component: () => import('@/views/SearchView.vue'),
                },
                {
                    path: ':pathMatch(.*)*',
                    name: 'not-found',
                    component: () => import('@/views/NotFoundView.vue'),
                },
            ],
        },
    ],
})

router.beforeEach(async (to) => {
    if (!to.meta.requiresAuth) return true

    const authStore = useAuthStore()

    if (!authStore.isAuthenticated) {
        await authStore.login()
        return false
    }

    if (to.meta.requiresAdmin && !authStore.isAdmin) {
        return { name: 'home' }
    }

    return true
})

export default router
